import { Dispatch, SetStateAction } from 'react';

import useDisclosure from '../../../shared/hooks/useDisclosure';
import {
  LandlordBooking,
  Status,
  TenantBooking,
} from '../../../types/bookings';
import BookingAcceptModal from '../BookingAcceptModal';
import BookingCounterOfferModal from '../BookingCounterOfferModal';
import BookingRejectModal from '../BookingRejectModal';
import BookingRespondToReservation from '../BookingRespondToReservation';
import BookingReviewCounterOfferModal from '../BookingReviewCounterOfferModal';
import BookingActions from './BookingActions';
import { StyledWrapper } from './BookingInformation.styles';
import BookingInformationButton from './BookingInformationButton';
import BookingPaymentInformation from './BookingPaymentInformation';
import BookingRentInformation from './BookingRentInformation';
import BookingUserInformation from './BookingUserInformation';
interface BookingInformationProps {
  booking: LandlordBooking | TenantBooking;
  setBookings: Dispatch<SetStateAction<LandlordBooking[] | TenantBooking[]>>;
}

export function BookingInformation({
  booking,
  setBookings,
}: BookingInformationProps) {
  const {
    isOpen: isAcceptOpen,
    onOpen: onAcceptOpen,
    onClose: onAcceptClose,
  } = useDisclosure();
  const {
    isOpen: isCounterOfferOpen,
    onOpen: onCounterOfferOpen,
    onClose: onCounterOfferClose,
  } = useDisclosure();
  const {
    isOpen: isTenantCounterOfferOpen,
    onOpen: onTenantCounterOfferOpen,
    onClose: onTenantCounterOfferClose,
  } = useDisclosure();
  const {
    isOpen: isRejectOpen,
    onOpen: onRejectOpen,
    onClose: onRejectClose,
  } = useDisclosure();
  const action_available = booking.status === Status.ACCEPTED;
  return (
    <>
      {isAcceptOpen && (
        <BookingAcceptModal
          onClose={onAcceptClose}
          booking={booking as LandlordBooking}
          setBookings={
            setBookings as Dispatch<SetStateAction<LandlordBooking[]>>
          }
        />
      )}
      {isCounterOfferOpen && (
        <BookingCounterOfferModal
          onClose={onCounterOfferClose}
          booking={booking as LandlordBooking}
          setBookings={
            setBookings as Dispatch<SetStateAction<LandlordBooking[]>>
          }
        />
      )}
      {isRejectOpen && (
        <BookingRejectModal
          onClose={onRejectClose}
          booking={booking as LandlordBooking}
          setBookings={
            setBookings as Dispatch<SetStateAction<LandlordBooking[]>>
          }
        />
      )}
      {isTenantCounterOfferOpen && (
        <BookingReviewCounterOfferModal
          onClose={onTenantCounterOfferClose}
          booking={booking as TenantBooking}
          setBookings={setBookings as Dispatch<SetStateAction<TenantBooking[]>>}
        />
      )}
      <StyledWrapper>
        <BookingRentInformation
          periodStart={booking?.period.start}
          periodEnd={booking?.period.end}
          propertyId={String(booking?.property.id)}
          numberOfGuests={booking?.number_of_guests}
        />
        <BookingUserInformation booking={booking} />
        <BookingPaymentInformation booking={booking} />
        <BookingRespondToReservation booking={booking} />
        <BookingInformationButton
          booking={booking}
          onAcceptOpen={onAcceptOpen}
          onRejectOpen={onRejectOpen}
          onCounterOfferOpen={onCounterOfferOpen}
          onTenantCounterOfferOpen={onTenantCounterOfferOpen}
        />
        {action_available && <BookingActions booking={booking} />}
      </StyledWrapper>
    </>
  );
}
